<template>
  <div class="agreement">
    <h2 class="center">
      <strong>万商星集隐私权政策</strong>
    </h2>
    <p class="sp_rf">最近更新日期：2022年8月24日</p>
    <p class="sp_cl">
      上海宜揉网络科技有限公司
      <strong class="sp_underLine">
        （以下称“万商星集”或“我们”）非常重视用户的隐私和个人信息保护。您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关信息。我们希望通过《万商星集隐私权政策》（“本隐私权政策”或“本政策”）向您说明我们在您使用我们的产品与/或服务时如何收集、使用、保存、共享和转让这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。本隐政策作为《用户服务协议》不可分割的一部分，未尽事宜适用《用户服务协议》约定。
      </strong>
    </p>
    <p class="sp_cl">
      本政策与您所使用的万商星集服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本政策所写明的内容，特别应重点阅读我们以<strong>粗体/粗体</strong>下划线标识的条款，确保您充分理解和同意之后再开始使用。本政策中涉及的相关术语，我们尽量以简明通俗向您解释，以便您更好地理解。
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        您同意本政策表示您已了解应用提供的功能，以及功能运行所需的必要个人信息，并给予相应的收集使用授权，但并不代表您已单独同意开启附加功能、处理非必要个人信息，相关附加功能的开启、处理非必要个人信息以及处理敏感个人信息，我们会根据您的实际使用情况单独征求您的同意。
      </strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        本政策将帮助您了解以下内容：
      </strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        一、适用范围
      </strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        二、信息收集及使用
      </strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        三、对外提供信息
      </strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        四、您的权利
      </strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        五、信息的存储
      </strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        六、未成年人保护
      </strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        七、政策的更新
      </strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        八、联系方式
      </strong>
    </p>
    <br>
    <p class="sp_cl">
      <strong class="sp_underLine">
        一、适用范围
      </strong>
    </p>
    <p class="sp_cl">
      本政策适用于我们以网站、客户端、小程序以及随技术发展出现的新形态向您提供的各项产品和服务。除本政策说明的相关信息收集使用活动外，本政策不适用于万商星集平台上的第三方向您提供的其他服务，其他服务适用其向您另行说明的个人信息收集使用规则。
    </p>
    <br>
    <p class="sp_cl">
      <strong>二、信息收集和使用</strong>
    </p>
    <p class="sp_cl">
      个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，包括但不限于
      <strong>自然人的姓名、出生日期、身份证件号码、个人生物识别信息、 住址、电话号码</strong>等。
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">个人敏感信息指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，本隐私权政策中涉及的个人敏感信息包括身份证件号码、手机号码、行踪轨迹、交易信息等。 </strong>
    </p>
    <p class="sp_cl">
      我们会出于本政策所述的以下目的，收集和使用您的个人信息：
    </p>
    <p class="sp_cl"><strong>（一）用户注册</strong></p>
    <p class="sp_cl">您首先需要注册一个万商星集账户成为万商星集用户。</p>
    <p class="sp_cl">
      1、在您注册万商星集账户或使用万商星集服务时，您需要提供您的<strong
              class="sp_underLine">手机号码</strong>。如您不提供上述信息，将无法注册账户或无法为您提供服务。同时为了验证该类信息的准确性和完整性，您同意我们将您提供的信息提供给其他合法保存您信息的机构（如政府机关、事业单位、万商星集关联公司和合作伙伴等）进行验证核对；我们会确保该等验证机构提供的信息来源合法性以便不会侵犯您的利益。
    </p>
    <p class="sp_cl">2、您可以修改补充您的昵称、性别、职业以及您的实名验证等相关信息，这些信息均属于您的“账户信息”。您补充的账户信息将有助于我们为您提供更多的服务。</p>
    <p class="sp_cl"><strong
              class="sp_underLine">在注册会员过程中，如果您提供以下额外信息补全个人资料，将有助于我们给您提供如会员生日特权等更多的会员服务：您的真实姓名、身份证号码、性别、出生年月日、城市、职业、您本人的真实头像。但如果您不提供这些信息，将会影响到您使用相应的会员服务，但不会影响使用万商星集产品或服务的基本浏览、搜索、购买功能。
      </strong></p>
    <p class="sp_cl">
      <strong>（二）实名认证</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        若您需要实现从账户进行付款和提现的功能，则您需要按照相关反洗钱法律法规的要求进行实名认证，您需要向我们提供您的姓名、身份证号码进行实名认证，我们会将您的姓名和身份证号码提供给第三方支付机构。
      </strong>
    </p>
    <p class="sp_cl"><strong>（三）支付</strong></p>
    <p class="sp_cl">
      在您对商品或服务下单后，您可以选择与万商星集合作的第三方支付机构（商盟商务服务有限公司）所提供的支付服务（包括付款和提现等服务）。在使用支付服务前，您需要提供您的<strong>
        <u>
          姓名、身份证号码、银行卡号、手机号、身份证正反面照片用于开通支付账户
        </u>
        ，同时我们需要将您的订单号、商品信息、交易金额等交易信息与支付机构共享以实现其确认您的支付指令并完成支付，此外我们还会将您开通、使用万商鼎集钱包的账户金额信息与支付机构共享以便您能正常使用钱包功能。</strong>
    </p>
    <p class="sp_cl"><strong>（四）投诉处理</strong></p>
    <p class="sp_cl">
      为了保护您及他人的合法权益，维护绿色购物环境，如您被他人投诉或投诉他人，我们会将您的<strong class="sp_underLine">姓名及身份证号码</strong>、投诉相关内容提供给消费者权益保护部门及监管机关，以便及时解决投诉纠纷；但法律法规明确禁止提供的除外。
    </p>
    <p class="sp_cl"><strong>（五）风险防范</strong></p>
    <p class="sp_cl">
      为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或<strong>万商星集</strong>相关协议规则的情况，<strong
              class="sp_underLine">我们可能使用或整合您的会员信息、交易信息、设备信息、有关网络日志以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</strong>我们会收集关于您使用的服务以及使用方式的信息并将这些信息进行关联，这些信息包括：
    </p>
    <p class="sp_cl">
      1、设备信息：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（例如设备型号、操作系统版本、设备设置、唯一设备标识符、Android ID等软硬件特征信息）、设备所在位置相关信息（例如IP 地址、GPS位置以及能够提供相关信息的Wi-Fi 接入点、蓝牙和基站等传感器信息）。
    </p>
    <p class="sp_cl">
      2、日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。例如您的搜索查询内容、IP地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间及您访问的网页记录等。
    </p>
    <p class="sp_cl">
      请注意，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。
    </p>
    <p class="sp_cl"><strong>（六）为了提供服务状态通知及查询服务</strong></p>
    <p class="sp_cl">
      为了遵守法律法规及监管规定，也为了便于您查询交易状态或历史记录，我们会将您使用万商星集服务时的
      <strong class="sp_underLine">身份信息、交易信息、行为信息</strong>进行存档，并严格按照法律法规的规定对这些信息进行妥善保管。为了使您知晓使用万商星集服务的状态，我们会根据这些信息向您发送服务状态通知。
    </p>
    <p class="sp_cl"><strong>（七）向您提供商品或服务</strong></p>
    <p class="sp_cl"><strong>1、您向我们提供的信息</strong></p>
    <p class="sp_cl">
      为了向您提供众包服务的申请、推荐、承接、作业等信息化服务，您自主进行申请、承接众包服务和具体服务作业的工作时，我们将收集您的
      <strong>
        姓名、手机号、证件类型、证件号码、身份证正面照、身份证背面照、银行卡号，
      </strong>
      以及您在此过程中自主填写的
      <strong>
        任务、项目、时间、服务内容、服务金额、成员信息、作业凭证
      </strong>
      （作业时间、作业任务、作业明细、作业过程凭证、作业完成凭证）、
      <strong>承接、地理位置</strong>
      等信息，以及您通过向平台上传的信息（文字、图片或音视频）；为了您方便您查询和管理您的一个或多个任务，我们会收集您自主提供的<strong>账户信息</strong>，包括：a.现金类账户信息：账户名、银行卡账号、支付账户账号、账户余额、账户币种、账户备注，b.平台账户信息：账户名、用户名、账户余额、账户币种、账户备注。
      <strong>
        同时我们需要将您的姓名、手机号、证件类型、证件号码、身份证正面照、身份证背面照、银行卡号、任务信息提交给任务发布方、任务分包方/众包方以实现任务分包方/众包方为您分包任务、支付生产经营收入及缴纳税费。
      </strong>
    </p>
    <p class="sp_cl"><strong>2、我们在您使用服务过程中收集的信息</strong></p>
    <p class="sp_cl">
      为改进服务质量，<strong class="sp_underLine">方便您使用商品搜索服务，我们会收集您的搜索记录，以便您下次搜索时不需要再重复输入相关关键词。</strong>
    </p>
    <p class="sp_cl"><strong>（八）系统权限的调用</strong></p>
    <table cellpadding="0" cellspacing="0" class="table_common">
      <thead>
        <tr>
          <th>设备权限</th>
          <th>对应的业务功能</th>
          <th>调用权限目的</th>
          <th>询问时间</th>
          <th>用户可否关闭权限</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, key) in tableData" :key="key">
          <td>{{ item.equipment }}</td>
          <td>{{ item.business }}</td>
          <td>{{ item.aims }}</td>
          <td>{{ item.time }}</td>
          <td>{{ item.whether }}</td>
        </tr>
      </tbody>
    </table>
    <p class="sp_cl"></p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。
      </strong>
    </p>
    <p class="sp_cl">
      为展示您账户的订单信息，我们会收集您在使用我们服务过程中产生的订单信息用于向您展示及便于您对订单进行管理。
    </p>
    <p class="sp_cl">
      当您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。
    </p>
    <p class="sp_cl">
      <strong>（九）我们通过间接获得方式收集到的您的个人信息</strong>
    </p>
    <p class="sp_cl">
      为确认交易状态及为您提供售后与争议解决服务，我们会通过您基于交易所选择的交易对象、物流公司等收集与交易进度相关的您的交易、物流信息，或将您的交易信息共享给上述服务提供者。
    </p>
    <p class="sp_cl"> <strong class="sp_underLine">当您通过我们产品或服务使用上述服务时，您授权我们根据实际业务及合作需要从我们关联公司处接收、汇总、分析我们确认其来源合法或您授权同意其向我们提供的您的个人信息或交易信息。</strong></p>
    <p class="sp_cl"> <strong class="sp_underLine">如您拒绝提供上述信息或拒绝授权，可能无法使用我们关联公司的相应产品或服务，或者无法展示相关信息。</strong></p>
    <p class="sp_cl sp_underLine"><strong>（十）来自第三方的信息</strong></p>
    <p class="sp_cl">
      当您与我们的关联公司、合作机构的服务时，为了共同向您提供服务的合理需要，您同意并授权我们收集您在我们的关联公司和合作机构合法留存或形成的与本服务相关的必要信息。
    </p>
    <p class="sp_cl">（1）您在我们关联公司或合作机构平台产生的<strong>账户、账号相关信息、交易信息</strong>等用以展示在我们的网页端或应用程序端，以供您查询和（或）统一管理。
    </p>
    <p class="sp_cl">
      <strong>（2）您向我们关联公司或合作机构提供的账户、注册相关信息用以在我们和关联公司平台间进行账号打通、注册之用途。</strong>
    </p>
    <p class="sp_cl">
      <strong>（3）您向我们关联公司或合作机构发送的开户信息、操作指令。</strong>
    </p>
    <p class="sp_cl">（4）为预防欺诈和确保安全，我们的关联公司、或合作机构会依据适用的法律法规或征得您同意、授权的前提下，向我们共享您的信息。</p>
    <p class="sp_cl">（5）本隐私权政策或其他协议中经您授权许可的其他收集方式下所收集的信息。</p>
    <p class="sp_cl"><strong>(十一）其他服务</strong></p>
    <p class="sp_cl"><strong>1、网站信标和像素标签</strong></p>
    <p class="sp_cl">
      我们会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。
    </p>
    <p class="sp_cl"><strong>2、Cookie和类似技术的使用</strong></p>
    <p class="sp_cl">
      当您使用平台服务时，为使您获得更轻松的访问体验，我们可能会使用各种技术来收集和存储信息，在此过程中可能会向您的设备发送一个或多个 Cookie 或匿名标识符。这么做是为了解您的使用习惯，使您省去重复输入注册信息等步骤，或帮助判断您的帐户安全。我们还可能会利用Cookie和类似技术收取您的信息用于了解您的偏好，进行咨询或数据分析，改善产品服务及用户体验，提高广告效果，及时发现并防范安全风险，为用户和第三方合作伙伴提供更好的服务
    </p>
    <p class="sp_cl">
      <strong>
        我们不会将Cookie用于本隐私权政策所述目的之外的任何用途，您可根据自己的偏好留存或删除Cookie。您可清除软件内保存的所有Cookie，当您手动清除后您的相关信息即已删除。
      </strong>
    </p>
    <br>
    <p class="sp_cl">
      <strong>三、对外提供信息</strong>
    </p>
    <p class="sp_cl">
      <strong>（一）共享</strong>
    </p>
    <p class="sp_cl">
      我们不会与万商星集服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：
    </p>
    <p class="sp_cl">
      1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
    </p>
    <p class="sp_cl">2、在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。</p>
    <p class="sp_cl">3、与关联公司间共享：<strong
              class="sp_underLine">为便于我们基于关联账号共同向您提供服务，或保护万商星集关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司共享。</strong>我们只会共享必要的个人信息，如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。
    </p>
    <p class="sp_cl">4、与授权合作伙伴共享：<strong
              class="sp_underLine">仅为实现本隐私权政策中声明的目的，我们的某些服务将由我们和授权合作伙伴共同提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。</strong>我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。<strong
              class="sp_underLine">我们的合作伙伴无权将共享的个人信息用于与产品或服务无关的其他用途。</strong></p>
    <p class="sp_cl"><strong class="sp_underLine">（二）委托处理</strong></p>
    <p class="sp_cl">
      我们可能委托授权合作伙伴处理您的个人信息，以便授权合作伙伴代表我们为您提供某些服务或履行职能。我们仅会出于本政策声明的合法、正当、必要、特定、明确的目的委托其处理您的信息，授权合作伙伴只能接触到其履行职责所需信息，且我们将会通过协议要求其不得将此信息用于其他任何超出委托范围的目的。如果授权合作伙伴将您的信息用于我们未委托的用途，其将单独征得您的同意。
    </p>
    <p class="sp_cl">目前，我们委托的授权合作伙伴包括以下类型：</p>
    <p class="sp_cl">
      1、广告、分析服务类的授权合作伙伴。我们会在采用行业通用的安全技术前提下，委托这些合作伙伴处理与广告投放、覆盖面和有效性相关的信息。我们不会将您的个人身份信息委托合作伙伴处理。
    </p>
    <p class="sp_cl">2、供应商、服务提供商和其他合作伙伴。我们将信息委托给支持我们业务的供应商、服务提供商和其他合作伙伴处理，这些支持包括受我们委托提供的技术基础设施服务、分析我们服务的使用方式、提供客户服务、支付便利或进行学术研究和调查。</p>
    <p class="sp_cl">
      为保障我们客户端的稳定运行、功能实现，使您能够使用和享受更多的服务及功能，我们的应用中会嵌入授权合作伙伴的SDK或其他类似的应用程序。我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照本政策以及其他任何相关的保密和安全措施来处理个人信息。
    </p>
    <p class="sp_cl"><strong>您可<a class="link"
           href="/#/sdkIllustration">点击此处</a>
        查看我们接入的SDK详情。</strong></p>
    <br>
    <p class="sp_cl"><strong>（三）转让</strong></p>
    <p class="sp_cl">
      我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
    </p>
    <p class="sp_cl">1、事先获得您明确的同意或授权；</p>
    <p class="sp_cl">
      2、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；
    </p>
    <p class="sp_cl">
      3、若我们因合并、分立、解散、被宣告破产的原因需要转移个人信息的，我们会向您告知接收方的名称或者姓名和联系方式。接收方将继续履行本政策及其他法定义务。接收方变更原先的处理目的、处理方式的，会重新取得您的同意。
    </p>
    <p class="sp_cl"><strong>（四）公开披露</strong></p>
    <p class="sp_cl">
      我们仅会在以下情况下，公开披露您的个人信息：
    </p>
    <p class="sp_cl">
      1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        2、如果我们确定您出现违反法律法规或严重违反万商星集相关协议规则的情况，或为保护万商星集及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或万商星集相关协议规则征得您同意的情况下披露关于您的个人信息。</strong>
    </p>
    <br>
    <p class="sp_cl">
      <strong class="sp_underLine">四、您的权利</strong>
    </p>
    <p class="sp_cl">
      您可以通过以下方式访问及管理您的个人信息：
    </p>
    <p class="sp_cl">
      （一）您可通过联系万商星集客服查阅或修改您的账户、个人信息。出于安全性和身份识别的考虑或根据法律法规的强制规定，您可能无法修改注册时提供的初始注册信息。
    </p>
    <p class="sp_cl">（二）如您发现我们采集、储存的您的个人信息有错误、不完整或有更新的，您可以联系我们要求更正。</p>
    <p class="sp_cl">
      （三）对于您的个人信息，您可以通过我们提供的相关服务的功能页面，主动删除您提供信息。一旦您删除后，我们即会对此类信息进行删除或匿名化处理，除非法律法规另有规定。
    </p>
    <p class="sp_cl">
      （四）我们提供的产品和服务的部分功能需要获得您使用设备的相关权限。您可以在授权后随时撤回（或停止）对该权限的继续授权。
    </p>
    <p class="sp_cl">
      （五）您可通过联系万商星集客服注销您的万商星集账户。注销万商星集账户后，您该账户内的所有信息将被清空，我们将不会再收集、使用或共享与该账户相关的个人信息，
      <strong class="sp_underLine">但之前的信息我们仍需按照监管要求的时间进行保存，且在该依法保存的时间内有权机关仍有权依法查询。</strong>
    </p>
    <p class="sp_cl">
      （六）如您发现我们采集、使用您个人信息的行为，违反了法律、行政法规规定或违反了与您的约定，您可联系我们，要求删除该违反行为下采集的您的个人信息。
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        （七）在响应您上述（一）、（二）、（三）项要求前，为保障安全，我们需要先验证您的身份和凭证资料，验证通过后将在三个工作日内处理完成；有特殊情形的，最长将在不超过三十天或法律法规规定期限内作出答复。如您不满意我们的答复，还可以向消费者权益保护部门投诉或向有管辖权的法院提起诉讼。
      </strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        （八）尽管有上述约定，但按照法律法规要求，在以下情形下，我们可能无法响应您的请求：
      </strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">1、与国家安全、国防安全有关的；</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">2、与公共安全、公共卫生、重大公共利益有关的；</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">3、与犯罪侦查、起诉和审判等有关的；</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">4、有充分证据表明您存在主观恶意或滥用权利的；</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">5、响应您的请求将导致其他个人、组织的合法权益受到严重损害的。</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">6、涉及商业秘密的</strong>
    </p>
    <br>
    <p class="sp_cl"><strong>五、信息的存储</strong></p>
    <p class="sp_cl">
      （一）我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。我们仅在本政策所述目的所必需期间和法律法规要求的时限内保留您的个人信息。
    </p>
    <p class="sp_cl">
      （二）我们承诺我们将使信息安全保护达到合理的安全水平。为保障您的信息安全，我们致力于使用各种安全技术及配套的管理体系来防止您的信息被泄露、毁损或者丢失，如通过网络安全层软件（SSL）进行加密传输、信息加密存储、严格限制数据中心的访问、使用专用网络通道及网络代理。同时我们建立了相关内控制度，对可能接触到您的信息的工作人员采取最小够用授权原则。如由于我们的失误导致您的信息被泄露，因此造成您的直接经济损失，我们将向您承担赔偿责任。
    </p>
    <p class="sp_cl">
      <strong>（三）</strong>
      <strong class="sp_underLine">请您理解，由于技术水平限制及可能存在的各种恶意手段，有可能因我们可控范围外的因素而出现问题。</strong>在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话或推送通知方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。如我们未履行上述义务导致您损失的，我们将赔偿您因此遭受的直接经济损失。
    </p>
    <p class="sp_cl">
      （四）如您通过我们的网站或客户端，使用了由第三方而非万商星集提供的服务时，我们无法保证这些第三方主体会按照我们的要求采取保护措施，为尽力确保您的账号安全，使您获得更安全的访问体验，我们可能会使用专用的网络协议及代理技术（称为“专用网络通道”、“网络代理”）。使用专用网络通道，可以帮助您识别到我们已知的高风险站点，减少由此引起的钓鱼、账号泄露等风险，同时更有利于保障您和第三方的共同权益，阻止不法分子篡改您和您希望访问的第三方之间正常服务内容，例如不安全路由器、非法基站等引起的广告注入、非法内容篡改等。在此过程中，我们也可能会获得和保存关于您计算机的相关信息，比如IP地址、硬件ID。
    </p>
    <p class="sp_cl">（五）如我们停止运营，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。 </p>
    <br>
    <p class="sp_cl">
      <strong>
        六、未成年人保护
      </strong>
    </p>
    <p class="sp_cl">
      未成年人使用我们的产品与/或服务前应取得其监护人的同意。如您为未成年人，在使用我们的产品与/或服务前，应在监护人监护、指导下共同阅读本政策且应在监护人明确同意和指导下使用我们的产品与/或服务、提交个人信息。我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律法规允许、监护人明确同意或保护您的权益所必要的情况下收集、使用或公开披露未成年人的个人信息。
    </p>
    <p class="sp_cl">
      若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，您可以通过本政策第八条“联系方式”中公示的联系方式与我们沟通解决。如果我们发现在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，则会尽快删除相关数据。
    </p>
    <br>
    <p class="sp_cl"><strong>七、政策的更新</strong></p>
    <p class="sp_cl"> <strong
              class="sp_underLine">基于业务功能、使用规则、联络方式、保存地域变更或法律法规及监管要求，我们可能会适时对本政策进行修订。由于万商星集的用户较多，如本政策发生变更，我们将以在平台公告、短信推送、电子邮件或其他方式来通知您。</strong>但未经您明确同意，我们不会限制您按照本政策所享有的权利。对于重大变更，我们还会提供更为显著的通知（如向您提供弹窗提示）。
    </p>
    <p class="sp_cl">本政策所指的重大变更包括但不限于：</p>
    <p class="sp_cl">
      1、产品的业务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式；
    </p>
    <p class="sp_cl">2、业务调整、交易并购引起的隐私政策的主体变更，新主体接收方变更原先的处理目的、处理方式；</p>
    <p class="sp_cl">
      3、个人信息共享或公开披露的主要对象发生变化；
    </p>
    <p class="sp_cl">
      4、用户个人信息权利及其行使方式发生重大变化；
    </p>
    <p class="sp_cl">5、处理个人信息保护负责人的联络方式及投诉渠道发生变化时；</p>
    <p class="sp_cl">6、个人信息保护影响评估报告表明产品存在对个人权益有重大影响时。</p>
    <br>
    <p class="sp_cl"><strong>八、联系方式</strong></p>
    <p class="sp_cl">
      如果您对本协议有任何问题，请通过以下途径联系万商星集，平台会尽最大努力在合理时间内对您的问题进行回复和处理：
    </p>
    <p class="sp_cl">万商星集公司全称：上海宜揉网络科技有限公司</p>
    <p class="sp_cl">注册地址：上海市徐汇区宜山路1289号7幢608室</p>
    <p class="sp_cl">常用办公地址：浙江省杭州市余杭区五常街道西溪八方城9幢7楼</p>
    <p class="sp_cl">
      信息保护负责人联系方式： 4000128128  （工作日 9:00-18:00 周末 9:00-17:00）
    </p>
  </div>
</template>
<script>
export default {
  name: 'privacyPolicy',
  data() {
    return {
      tableData: [
        {
          equipment: '位置（粗略位置和精准位置）',
          business: '首页附近商家展示',
          aims: '根据位置展示周边商家',
          time: '启动APP',
          whether: '可以',
        },
        {
          equipment: '照片、存储',
          business: '扫一扫、个人中心',
          aims: '读取相册实现照片或视频上传、扫码以及将照片或视频保存至手机',
          time: '上传照片或视频保存照片或视频到手机',
          whether: '可以',
        },
        {
          equipment: '相机',
          business: '扫一扫、个人中心',
          aims: '视频拍摄、拍照、扫码等功能',
          time: '拍摄、拍照',
          whether: '可以',
        },
        {
          equipment: '拨打电话',
          business: '客服服务',
          aims: '联系客服',
          time: '拨打电话前询问',
          whether: '可以',
        },
        {
          equipment: '开启移动数据',
          business: '全部功能',
          aims: '连接网络',
          time: '程序启动时检测网络状态',
          whether: '可以',
        },
        {
          equipment: '开启WLAN',
          business: '全部功能',
          aims: '连接网络',
          time: '程序启动时检测网络状态',
          whether: '可以',
        },
        {
          equipment: '读取手机状态和身份',
          business: '全部功能',
          aims: '保证支付以及用户数据安全',
          time: '不需要授权',
          whether: '可以',
        },
        {
          equipment: '近距离通讯操作',
          business: '用户支付',
          aims: '银联迷你付近场支付',
          time: '不需要授权',
          whether: '可以',
        },
      ],
      pluginData: [
        {
          equipment: '腾讯X5浏览器内核SDK',
          business: '解决原生webview性能低下与兼容性问题',
          aims: '存储权限、手机型号、剪切板内容',
          company: '深圳市腾讯计算机系统有限公司',
          secret: 'https://x5.tencent.com/docs/privacy.html。',
        },
        {
          equipment: '腾讯bugly',
          business: '用户使用中bug搜集',
          aims:
            '注册账户时填写的信息、使用服务时上传的信息、通过客服或参加举办的活动时所提交的信息、设备信息、软件信息、IP地址、服务日志信息、通讯日志信息、位置信息',
          company: '深圳市腾讯计算机系统有限公司',
          secret: 'https://privacy.qq.com/policy/tencent-privacypolicy',
        },
        {
          equipment: '百度OCR',
          business: '用于身份证识别',
          aims: 'IMEI',
          company: '百度在线网络技术（北京）有限公司',
          secret: 'https://map.baidu.com/zt/client/privacy/index.html',
        },
        {
          equipment: '百度地图定位',
          business: '用于地图定位',
          aims:
            '日历信息、通讯录信息、车辆信息、日志信息、位置信息、硬件型号、操作系统版本、设备配置、唯一设备标识符、网络设备硬件地址MAC、广告标识符IDFA信息、设备连接信息以及设备状态信息、网络身份标识、帐号名称、头像、密保邮箱、密保手机、密保问题，并创建密码',
          company: '百度在线网络技术（北京）有限公司',
          secret: 'https://map.baidu.com/zt/client/privacy/index.html',
        },
        {
          equipment: '支付宝支付',
          business: '用于支付宝支付、防欺诈、盗刷',
          aims: '设备IP、IMEI、Mac',
          company: '支付宝（中国）网络技术有限公司',
          secret: 'https://render.alipay.com/p/c/k2cx0tg8',
        },
        {
          equipment: '微信支付',
          business: '用于微信支付、防欺诈、盗刷',
          aims: '设备IP、IMEI、Mac',
          company: '深圳市腾讯计算机系统有限公司',
          secret:
            'https://weixin.qq.com/cgi-bin/readtemplate?uin=&stype=&promote=&fr=&lang=zh_CN&ADTAG=&check=false&nav=faq&t=weixin_agreement&s=pay',
        },
        {
          equipment: '迷你付',
          business: '用于银联支付、防欺诈、盗刷',
          aims: '设备IP、IMEI、Mac',
          company: '中国银联股份有限公司',
          secret: 'https://yunshanfu.unionpay.com/privacy/2',
        },
      ],
    }
  },
  methods: {},
}
</script>
<style scoped lang="less">
.agreement {
  text-align: left;
  padding: 30px;
  word-break: break-all;
  .sp_cl {
    text-indent: 2em;
  }
  .sp_rf {
    text-align: right;
  }
  .sp_underLine {
    text-decoration: underline;
  }
  .center {
    text-align: center;
  }
  .no_margin {
    margin: 0;
  }
  .table_common {
    width: 100%;
    text-align: center;
    border-top: 1px solid #000;
    border-left: 1px solid #000;
    th,
    td {
      border-right: 1px solid #000;
      border-bottom: 1px solid #000;
      padding: 0.3em;
    }
  }
}
</style>
